import {
  demoHighlightMeta,
  demoRequestHref,
  demoUseCases,
  demoUseCasesSection,
} from '@/content/site';
import { FeatureIcon } from '@/components/Icons';
import { ScrollReveal } from '@/components/ScrollReveal';
import { demoWebUrl } from '@/lib/demoUrl';
import { trackWhatsAppSalesClick } from '@/lib/tracking';
import './UseCaseDemos.css';

export function UseCaseDemos() {
  return (
    <section id={demoUseCasesSection.id} className="use-case-demos">
      <div className="container">
        <span className="section-label">{demoUseCasesSection.label}</span>
        <h2 className="section-title">{demoUseCasesSection.title}</h2>
        <p className="section-lead">{demoUseCasesSection.lead}</p>

        <div className="use-case-demos__grid">
          {demoUseCases.map((useCase, i) => {
            const demoUrl = demoWebUrl(useCase.id, useCase.demoToken);
            const highlight = demoHighlightMeta(useCase.highlight);
            const highlightClass = useCase.highlight
              ? ` use-case-card--${useCase.highlight}`
              : '';
            return (
              <ScrollReveal key={useCase.id} delay={(i % 3) * 70}>
                <article className={`use-case-card${highlightClass}`}>
                  <div className="use-case-card__meta">
                    <span className="use-case-card__category">{useCase.category}</span>
                    {highlight ? (
                      <span
                        className={`use-case-card__badge use-case-card__badge--${useCase.highlight}`}
                        aria-label={highlight.aria}
                      >
                        {highlight.badge}
                      </span>
                    ) : null}
                  </div>
                  <div className="use-case-card__icon" aria-hidden>
                    <FeatureIcon name={useCase.icon} />
                  </div>
                  <h3 className="use-case-card__title">{useCase.title}</h3>
                  <p className="use-case-card__body">{useCase.description}</p>
                  {demoUrl ? (
                    <a
                      className={`use-case-card__link${
                        useCase.highlight ? ` use-case-card__link--${useCase.highlight}` : ''
                      }`}
                      href={demoUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {highlight?.cta ?? 'Probar demo web'}
                      <span aria-hidden>→</span>
                    </a>
                  ) : (
                    <a
                      className="use-case-card__link use-case-card__link--muted"
                      href={demoRequestHref}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() =>
                        trackWhatsAppSalesClick(
                          'use_case_demos',
                          'Solicitar acceso a la demo',
                          demoRequestHref,
                        )
                      }
                    >
                      Solicitar acceso a la demo
                      <span aria-hidden>→</span>
                    </a>
                  )}
                </article>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
